import { createSelector } from 'reselect';

const getSearch = state => state.search;

export const getDebouncedSearchValue = createSelector(
  getSearch,
  search => search.debouncedSearchValue,
);

export const getCurrentSearchValue = createSelector(getSearch, search => search.currentSearchValue);
